<template>
    <div class="way-bill">
        <div>
            <el-form :inline="true" :model="formInline" class="demo-form-inline">
                <el-form-item label>
                    <el-input
                        v-model="formInline.orderNo"
                        placeholder="订单号"
                        size="mini"
                    ></el-input>
                </el-form-item>
                <el-form-item label>
                    <el-input
                        v-model="formInline.waybillCompany"
                        placeholder="物流公司"
                        size="mini"
                    ></el-input>
                </el-form-item>
                <el-form-item label>
                    <el-input
                        v-model="formInline.waybillNo"
                        placeholder="物流单号"
                        size="mini"
                    ></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="success" @click="getWayBill(1)" size="mini">查询</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div>
            <table>
                <tr class="th">
                    <td>订单号</td>
                    <td>物流公司</td>
                    <td>物流单号</td>
                    <td>运单创建时间</td>
                    <td>操作</td>
                </tr>
                <tbody>
                    <tr v-for="(item, index) in wayBills.list" :key="index">
                        <td>{{ item.orderNo }}</td>
                        <td>{{ item.waybillCompany }}</td>
                        <td>{{ item.waybillNo }}</td>
                        <td>{{ item.createTime }}</td>
                        <td>
                            <el-button type="success" size="mini" @click="handleDetail(item)"
                                >查看明细</el-button
                            >
                        </td>
                    </tr>
                </tbody>
            </table>
            <div
                class="table-empty"
                v-if="!wayBills || !wayBills.list || (wayBills.list && wayBills.list.length === 0)"
            >
                <i class="el-icon-document-copy"></i>
                <p>暂无数据</p>
            </div>
        </div>
        <div class="pagination">
            <el-pagination
                background
                layout="prev, pager, next,total"
                :total="wayBills.count"
                :page-size="wayBills.pageSize"
                :current-page="wayBills.page"
                @current-change="handleCurrentChange"
            ></el-pagination>
        </div>

        <el-dialog title="运单明细" :visible.sync="wayBillDialog" width="800px">
            <WayBill :wayBillId="currentWaybillId"></WayBill>
            <div slot="footer" class="dialog-footer"></div>
        </el-dialog>
    </div>
</template>

<script>
import * as apis from '../../fetch/order';

import WayBill from '../../components/order/WayBill.vue';

export default {
    name: 'way-bill',
    components: {
        WayBill,
    },
    data() {
        return {
            formInline: {
                orderNo: null,
                waybillCompany: null,
                waybillNo: null,
            },
            wayBills: [],
            wayBillDialog: false,
            currentWaybillId: null,
        };
    },
    methods: {
        handleCurrentChange(page) {
            this.getWayBill(page);
        },
        handleDetail(item) {
            this.wayBillDialog = true;
            this.currentWaybillId = item.id;
        },
        getWayBill(page = 1) {
            const params = {
                ...this.formInline,
                page,
            };
            apis.getWayBill(params).then(res => {
                this.wayBills = res;
            });
        },
    },
    mounted() {
        this.getWayBill();
    },
};
</script>

<style lang="less" scoped></style>
